const labels = JSON.parse(document.getElementById('BouchilinoR15Labels')?.textContent || '{}');
const isArabic = document.documentElement.lang.startsWith('ar');
const node = (tag, className, text) => {
  const element = document.createElement(tag);
  if (className) element.className = className;
  if (text !== undefined) element.textContent = text;
  return element;
};

class BouchilinoGallery extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.images = JSON.parse(this.querySelector('[data-b15-images]')?.textContent || '[]');
    this.dialog = this.querySelector('dialog');
    if (!this.images.length || !this.dialog) return;
    this.index = 0;
    this.addEventListener('click', event => {
      const image = event.target.closest('[data-b15-image]');
      if (image) {
        event.preventDefault();
        this.showImage(Number(image.dataset.b15Image));
        this.dialog.showModal();
      }
      if (event.target.closest('[data-b15-close]')) this.dialog.close();
      const step = event.target.closest('[data-b15-step]');
      if (step) this.showImage(this.index + Number(step.dataset.b15Step));
    }, { signal });
    this.dialog.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      this.showImage(this.index + (event.key === 'ArrowRight' ? 1 : -1));
    }, { signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
  showImage(index) {
    this.index = (index + this.images.length) % this.images.length;
    const source = this.images[this.index];
    const image = node('img');
    image.src = source.src;
    image.alt = source.alt;
    this.querySelector('.b15-lightbox-stage').replaceChildren(image);
    this.querySelector('[data-b15-count]').textContent = `${this.index + 1} / ${this.images.length}`;
  }
}
customElements.define('bouchilino-gallery', BouchilinoGallery);

class BouchilinoDossier extends HTMLElement {
  connectedCallback() {
    const source = this.querySelector('[data-b15-description]');
    if (!source || source.dataset.enhanced) return;
    source.dataset.enhanced = 'true';
    // Only split the verified, simple catalogue structure. Future rich content stays intact.
    const simple = [...source.children].every(el => ['P', 'UL'].includes(el.tagName));
    const groups = { fabric: [], construction: [] };
    if (simple) {
      for (const row of source.querySelectorAll('ul > li')) {
        const key = /قطن|صوف|كشمير|إيلاستين|الخامة|cotton|wool|cashmere|elastane|fabric:/i.test(row.textContent) ? 'fabric' : 'construction';
        groups[key].push(row);
      }
      let after = source.closest('details');
      for (const key of ['fabric', 'construction']) {
        if (!groups[key].length) continue;
        const details = node('details', 'b15-description-section');
        details.open = key === 'fabric';
        details.append(node('summary', '', labels[key]));
        const copy = node('div', 'b15-description-copy');
        const list = node('ul');
        for (const row of groups[key]) list.append(row);
        copy.append(list);
        details.append(copy);
        after.after(details);
        after = details;
      }
      for (const list of source.querySelectorAll('ul')) if (!list.children.length) list.remove();
    }
    const section = this.closest('.product-information');
    const gallery = section?.querySelector('bouchilino-gallery');
    if (!gallery) return;
    const handle = location.pathname.split('/').pop();
    const jackets = ['marco-pescarolo-forza-0-reversible-jacket-sand-taupe', 'marco-pescarolo-forza-0-reversible-jacket-pearl-grey'];
    const known = jackets.includes(handle) || handle === 'cruciani-open-collar-polo-stone';
    if (!known) return;
    for (const [index, details] of [...this.querySelectorAll('details')].entries()) {
      if (index > 2) break;
      const button = node('button', 'b15-compare-link', labels.compare);
      button.type = 'button';
      details.querySelector('.b15-description-copy').append(button);
      button.addEventListener('click', () => {
        const indices = index === 2 ? (jackets.includes(handle) ? [2, 3] : [0, 3]) : [0, 1];
        for (const figure of gallery.querySelectorAll('[data-b15-figure]')) {
          const related = indices.includes(Number(figure.dataset.b15Figure));
          figure.classList.toggle('b15-is-related', related);
          figure.querySelector('[data-b15-related]').textContent = related ? labels.related : '';
        }
        gallery.querySelector('[data-b15-compare-status]').textContent = labels.highlighted + details.querySelector('summary').textContent;
        if (innerWidth < 750) gallery.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
    }
  }
}
customElements.define('bouchilino-dossier', BouchilinoDossier);

const privacyNav = {
  'Personal Information We Collect or Process':'البيانات التي نجمعها أو نعالجها',
  'Personal Information Sources':'مصادر البيانات الشخصية',
  'How We Use Your Personal Information':'استخدام البيانات الشخصية',
  'How We Disclose Personal Information':'مشاركة البيانات الشخصية',
  'Relationship with Shopify':'العلاقة مع Shopify',
  'Third Party Websites and Links':'المواقع والروابط الخارجية',
  "Children's Data":'بيانات الأطفال',
  'Security and Retention of Your Information':'أمان البيانات والاحتفاظ بها',
  'Your Rights and Choices':'حقوقك وخياراتك',
  'Complaints':'الشكاوى',
  'International Transfers':'نقل البيانات دوليًا',
  'Changes to This Privacy Policy':'تحديثات السياسة',
  'Contact':'التواصل'
};

function enhancePolicy() {
  if (document.querySelector('[data-b20-policy]')) return;
  const privacy = location.pathname.endsWith('/policies/privacy-policy');
  const source = privacy ? document.querySelector('.shopify-policy__container') : document.querySelector('[data-b15-policy="returns"]');
  if (!source || source.dataset.enhanced) return;
  const body = source.querySelector(privacy ? '.shopify-policy__body' : '[data-b15-policy-body]');
  if (!body) return;
  source.dataset.enhanced = 'true';
  // Legacy presentation only: retain every published legal text node and link.
  for (const style of body.querySelectorAll('style')) style.remove();
  for (const element of body.querySelectorAll('[style]')) element.removeAttribute('style');
  source.className = 'b15 b15-policy';
  const title = privacy ? labels.privacy : labels.returns;
  const crumb = node('div', 'b15-breadcrumb b15-shell');
  const home = node('a', '', labels.home);
  home.href = window.Shopify?.routes?.root || (isArabic ? '/' : '/en/');
  crumb.append(home, node('span', '', '/'), node('span', '', title));
  const opening = node('header', 'b15-page-opening b15-green');
  const openingGrid = node('div', 'b15-shell b15-opening-grid');
  const heading = node('div');
  heading.append(node('p', 'b15-eyebrow', 'BOUCHILINO · ABU DHABI'), node('h1', '', title));
  openingGrid.append(heading);
  if (!privacy && /15/.test(body.textContent)) {
    const stat = node('div', 'b15-policy-intro-stat', '15');
    stat.append(node('small', '', labels.days));
    openingGrid.append(stat);
  } else if (privacy) openingGrid.append(node('p', 'b15-lead', labels.privacy_lead));
  opening.append(openingGrid);
  const layout = node('div', 'b15-shell b15-policy-layout');
  const index = node('aside', 'b15-policy-index');
  index.append(node('h2', '', labels.contents));
  const nav = node('nav');
  nav.setAttribute('aria-label', labels.contents);
  const copy = node('article', 'b15-policy-copy');
  if (privacy && isArabic) copy.append(node('p', 'b15-policy-language', labels.privacy_note));
  const controls = node('div', 'b15-policy-tools');
  const print = node('button', 'b15-compare-link', labels.print);
  print.type = 'button';
  print.addEventListener('click', () => window.print());
  controls.append(node('span', 'b15-note', labels.full_policy), print);
  copy.append(controls);
  body.className = 'b15-policy-original';
  if (privacy) { body.lang = 'en'; body.dir = 'ltr'; }
  body.id = 'B15PolicyIntroduction';
  const intro = node('a', '', labels.introduction);
  intro.href = '#B15PolicyIntroduction';
  nav.append(intro);
  for (const [i, chapter] of [...body.querySelectorAll('h2,h3')].entries()) {
    chapter.id = `B15PolicyChapter-${i}`;
    const text = chapter.textContent.trim();
    const link = node('a', '', privacy && isArabic ? (privacyNav[text] || text) : text);
    link.href = `#${chapter.id}`;
    nav.append(link);
  }
  index.append(nav);
  copy.append(body);
  layout.append(index, copy);
  source.replaceChildren(crumb, opening, layout);
}
enhancePolicy();

document.addEventListener('change', event => {
  if (!event.target.matches('[data-b15-topic]')) return;
  const form = event.target.closest('form');
  const order = form.querySelector('[data-b15-order]');
  order.hidden = event.target.dataset.b15Topic !== '1';
  order.querySelector('input').disabled = order.hidden;
});

async function populateEnquiry() {
  const form = document.querySelector('.b15-service form');
  const handle = new URLSearchParams(location.search).get('product');
  const message = form?.querySelector('textarea[name="contact[body]"]');
  if (!message || message.value.trim() || !handle || !/^[a-z0-9-]+$/.test(handle)) return;
  const root = window.Shopify?.routes?.root || (isArabic ? '/' : '/en/');
  try {
    const response = await fetch(new URL(`${root}products/${handle}.js`, location.origin));
    if (!response.ok) return;
    const product = await response.json();
    if (!message.value.trim() && product.title) message.value = `${labels.enquire}: ${product.title}`;
  } catch { /* Optional context; the native contact form remains fully usable. */ }
}
populateEnquiry();
